import React from 'react';
import { Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { theme } from '../../styles/theme';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

interface ResultChartProps {
  scores: { [dimensionId: string]: number };
  labels: { [dimensionId: string]: string };
}

const ResultChart: React.FC<ResultChartProps> = ({ scores, labels }) => {
  // Order keys to ensure consistent display
  const dimensionKeys = Object.keys(scores);
  const chartLabels = dimensionKeys.map(key => labels[key]);
  const chartData = dimensionKeys.map(key => scores[key]);

  const data = {
    labels: chartLabels,
    datasets: [
      {
        label: 'Maturity Score',
        data: chartData,
        backgroundColor: 'rgba(13, 127, 233, 0.2)',
        borderColor: theme.colors.primary,
        borderWidth: 2,
        pointBackgroundColor: theme.colors.primary,
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: theme.colors.primary,
      },
    ],
  };

  const options = {
    scales: {
      r: {
        angleLines: {
          display: true,
          color: theme.colors.lightGray
        },
        suggestedMin: 0,
        suggestedMax: 5,
        ticks: {
            stepSize: 1,
            showLabelBackdrop: false,
        }
      },
    },
    plugins: {
        legend: {
            display: false
        }
    }
  };

  return <Radar data={data} options={options} />;
};

export default ResultChart;